'use es6';

import { useEffect, useRef } from 'react';
import EmojiPickerPopover from './EmojiPickerPopover';
import useInlineTarget from '../utils/hooks/useInlineTarget';
import { HS_INPAGE_SETTINGS } from '../constants/hsSettings';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EmojiPopoverManager(props) {
  const {
    editor,
    EmojiPicker,
    storeHandlers,
    onInsert,
    onOpenChange
  } = props;
  const {
    inlineTarget,
    setInlineTarget,
    initInlineTarget,
    insertAtInlineTarget
  } = useInlineTarget(editor, null);
  const lastTarget = useRef(inlineTarget);
  useEffect(() => {
    lastTarget.current = inlineTarget;
  });
  useEffect(() => {
    const handleOpenPopover = () => {
      if (lastTarget.current) {
        setInlineTarget(null, {
          restoreSelection: true
        });
      } else {
        if (editor.settings[HS_INPAGE_SETTINGS]) {
          storeHandlers.init(() => initInlineTarget({
            fireNodeChange: true
          }));
        } else {
          initInlineTarget({
            fireNodeChange: true
          });
        }
      }
    };
    editor.on('OpenEmojiPopover', handleOpenPopover);
    editor.on('PreloadEmojiPicker', EmojiPicker.preload);
    return () => {
      editor.off('OpenEmojiPopover', handleOpenPopover);
      editor.off('PreloadEmojiPicker', EmojiPicker.preload);
    };
  }, [editor, EmojiPicker, storeHandlers, initInlineTarget, setInlineTarget]);
  useEffect(() => {
    onOpenChange(!!inlineTarget);
  }, [onOpenChange, inlineTarget]);
  const handleRemove = () => {
    if (lastTarget.current) {
      setInlineTarget(null);
    }
  };
  const handleInsert = (...args) => {
    insertAtInlineTarget(onInsert.bind(null, ...args));
  };

  // Don't close if opened by the toolbar button or an emoji is clicked
  const shouldCloseOnClick = evt => {
    const isToolbarButton = evt && evt.target && editor.dom.getParent(evt.target, '.mce-toolbar,.mce-hubspot-popover,.mce-hubspot-dropdown');
    return !isToolbarButton;
  };
  return /*#__PURE__*/_jsx(EmojiPickerPopover, {
    "data-test-id": "emoji-popover-manager",
    tabIndex: "-1",
    editor: editor,
    open: !!inlineTarget,
    target: inlineTarget,
    onRemove: handleRemove,
    onOpenChange: handleRemove,
    onInsertEmoji: handleInsert,
    storeHandlers: storeHandlers,
    EmojiPicker: EmojiPicker,
    shouldCloseOnClick: shouldCloseOnClick,
    arrowSize: "medium",
    placement: "bottom right",
    autoPlacement: "vert"
  });
}